import { injectable } from 'inversify'

/**
 * Wraps crypto.randomUUID (invariant 8: all browser APIs behind a gateway).
 */
@injectable()
export class IdGeneratorGateway {
  generate(): string {
    return crypto.randomUUID()
  }
}
